import { LoadingSpinner } from "@newsela/angelou";

import AdminConsoleImplementationGuidePage from "@/admin/AdminConsoleImplementationGuidePage";
import withAdminContentPrivileges from "@/admin/withAdminContentPrivileges";
import NewselaGlobalLayout from "@/base";
import RootProviders from "@/base/RootProviders";
import ErrorPage from "@/errors/ErrorPage";
import NotAllowedError from "@/errors/NotAllowedError";
import useHasFeature from "@/features/useHasFeature";

const AdminConsoleImplementationGuidePageRoute = () => {
  //  Authentication group to access the Admin quick start.
  const [hasFeatureToAccessImplementationGuide, { loading, error }] =
    useHasFeature("can_access_implementation_guide");

  if (loading) {
    return <NewselaGlobalLayout mainContents={<LoadingSpinner />} />;
  }

  if (!hasFeatureToAccessImplementationGuide && error) {
    return <NewselaGlobalLayout mainContents={<ErrorPage />} />;
  }

  if (!hasFeatureToAccessImplementationGuide) {
    return <NewselaGlobalLayout mainContents={<NotAllowedError />} />;
  }

  return (
    <NewselaGlobalLayout
      mainContents={<AdminConsoleImplementationGuidePage />}
    />
  );
};

export async function getServerSideProps(ctx) {
  const RootProvidersInitialProps = await RootProviders.__getInitialProps({
    ctx,
  });

  return {
    props: {
      [RootProviders.InitialPropsName]: RootProvidersInitialProps,
    },
  };
}

export default withAdminContentPrivileges(
  AdminConsoleImplementationGuidePageRoute,
);
